'use client';
import { useState } from 'react';
 import Icon from'@/components/ui/AppIcon';

export default function NewsletterSection() {
  const [email, setEmail] = useState('')
  const [isSubmitted, setIsSubmitted] = useState(false)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    // Mock submission
    setIsSubmitted(true)
    setTimeout(() => {
      setIsSubmitted(false)
      setEmail('')
    }, 3000)
  }

  return (
    <section className="py-24 px-6 bg-gradient-to-br from-primary/10 via-accent/5 to-secondary/10 reveal">
      <div className="max-w-4xl mx-auto text-center">
        {/* Decorative Icon */}
        <div className="inline-flex items-center justify-center w-16 h-16 bg-primary rounded-2xl mb-6 shadow-lg">
          <Icon name="EnvelopeIcon" size={32} className="text-white" />
        </div>

        {/* Headline */}
        <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-4">
          Daily Saint in Your Inbox
        </h2>
        <p className="text-lg text-muted-foreground mb-10 max-w-2xl mx-auto">
          Receive daily saint stories, prayers, and inspiration. Join 50,000+ Catholics growing in faith.
        </p>

        {/* Newsletter Form */}
        <form onSubmit={handleSubmit} className="max-w-md mx-auto">
          <div className="flex flex-col sm:flex-row gap-3">
            <div className="relative flex-1">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
                className="w-full h-14 bg-card border-2 border-border rounded-xl px-5 text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary transition-colors"
              />
            </div>
            <button
              type="submit"
              disabled={isSubmitted}
              className="h-14 bg-primary text-white font-semibold rounded-xl px-8 hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {isSubmitted ? (
                <>
                  <Icon name="CheckIcon" size={20} />
                  <span>Subscribed!</span>
                </>
              ) : (
                <>
                  <span>Subscribe</span>
                  <Icon name="ArrowRightIcon" size={20} />
                </>
              )}
            </button>
          </div>
          <p className="text-xs text-muted-foreground mt-4">
            No spam. Unsubscribe anytime. We respect your privacy.
          </p>
        </form>

        {/* Trust Indicators */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-8">
          <div className="flex items-center gap-2">
            <Icon name="UserGroupIcon" size={20} className="text-primary" />
            <span className="text-sm text-muted-foreground">50,000+ subscribers</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="ShieldCheckIcon" size={20} className="text-primary" />
            <span className="text-sm text-muted-foreground">Privacy protected</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="BoltIcon" size={20} className="text-primary" />
            <span className="text-sm text-muted-foreground">Daily inspiration</span>
          </div>
        </div>
      </div>
    </section>
  )
}